import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["bar"];

  connect() {
    this.duration = 4000;
    // this.timeout = setTimeout(() => {
    //   this.startAnimation();
    // }, 1000);

    this.startAnimation();
    this.element.addEventListener("mouseenter", this.pause.bind(this));
    this.element.addEventListener("mouseleave", this.resume.bind(this));
  }

  disconnect() {
    // this.pause();
    this.element.removeEventListener("mouseenter", this.pause);
    this.element.removeEventListener("mouseleave", this.resume);
    this.element.remove();
  }

  startAnimation() {
    // const progressBar = this.element.querySelector(".progress-bar");
    const progressBar = this.barTarget;

    if (this.hasBarTarget) {
      progressBar.style.transition = `width ${this.duration}ms linear`;

      // Force un reflow pour que la transition démarre correctement
      progressBar.offsetHeight;

      progressBar.style.width = "0%";
    }

    this.timeout = setTimeout(() => {
      this.disconnect();
    }, this.duration);
  }

  pause() {
    const progressBar = this.barTarget;
    // const progressBar = this.element.querySelector(".progress-bar");
    const computedWidth = getComputedStyle(progressBar).width;

    progressBar.style.transition = "none";
    progressBar.style.width = computedWidth;

    clearTimeout(this.timeout);
  }

  resume() {
    const progressBar = this.barTarget;
    // const progressBar = this.element.querySelector(".progress-bar");
    const remainingWidth = parseFloat(progressBar.style.width);
    const remainingTime = (remainingWidth / 100) * this.duration;

    progressBar.style.transition = `width ${remainingTime}ms linear`;
    progressBar.style.width = "0%";

    this.timeout = setTimeout(() => {
      this.element.remove();
    }, remainingTime);
  }
}
